import React from 'react';
import { iconPropTypes } from '@Theme/natucare/components/Icon/IconPropTypes';
import { ICONS } from '@Theme/natucare/constants/icons.js';
const Icon = ({
  name,
  path,
  viewBox,
  size,
  onClick,
  classname,
  ...props
}) => {
  var _ICONS$name, _ICONS$name2;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    onClick: onClick,
    viewBox: ((_ICONS$name = ICONS[name]) === null || _ICONS$name === void 0 ? void 0 : _ICONS$name.viewBox) || viewBox,
    className: classname || '',
    fillRule: "evenodd",
    fill: "transparent",
    height: (size === null || size === void 0 ? void 0 : size.height) || null,
    width: (size === null || size === void 0 ? void 0 : size.width) || null
  }, props, {
    dangerouslySetInnerHTML: {
      __html: `${((_ICONS$name2 = ICONS[name]) === null || _ICONS$name2 === void 0 ? void 0 : _ICONS$name2.path) || path}`
    }
  }));
};
export default Icon;